import * as React from "react";

import { toCamelCase } from "kanopi-components/utils/string";
import { useGlobal } from "kanopi-components/useGlobal";

import api, { $ } from "kw/api";
import { useGlobalsContext } from "kw/util/Globals";
import { coverFields } from "kw/api/fragments";

export function useCovers(args?) {
  const globalsContext = useGlobalsContext();
  const [data = {}, setData] = useGlobal(globalsContext);
  const { riskProfile = {}, covers } = data;
  const riskProfileId = args?.riskProfileId || riskProfile.id || data?.profile?.id;
  const [loading, setLoading] = React.useState(!covers);
  React.useEffect(() => {
    async function fetch() {
      setLoading(true);
      try {
        const covers = await queryCovers(riskProfileId);
        setData({ covers });
      } finally {
        setLoading(false);
      }
    }
    if (riskProfileId) {
      fetch();
    }
  }, [riskProfileId]);
  return [covers || [], { loading }];
}

async function queryCovers(riskProfileId) {
  const response = await api.query(getCoversQuery(riskProfileId));
  // TODO: I'd love to make this nicer.
  const covers = (response.availableCovers || []).map((c) => ({
    ...c,
    key: toCamelCase(c.key),
    parentCover: coerceParentCover(c.parentCover),
    subCovers: coerceSubCovers(c.subCovers),
    coverQuestionSets: (c.coverQuestionSets || [])
      .filter(
        // Filter out any question sets that belong in a nested form input
        (cqs) => !cqs?.questionSet?.parentQuestions?.length
      )
      .map((cqs) => ({
        ...cqs,
        questionSet: {
          ...cqs.questionSet,
          questions: (cqs.questionSet.questions || []).map((q) => ({
            ...q,
            storagePath: toCamelCase(q.storagePath),
          })),
        },
      })),
  }));
  return covers;
}

export function getCoversQuery(riskProfileId) {
  return {
    availableCovers: [
      {
        riskProfileId,
      },
      {
        ...coverFields,
      },
    ],
  };
}

function coerceParentCover(parentCover) {
  if (parentCover) {
    return {
      ...parentCover,
      key: toCamelCase(parentCover.key),
    };
  }
  return null;
}

function coerceSubCovers(subCovers) {
  return subCovers.map((sc) => ({
    ...sc,
    key: toCamelCase(sc.key),
  }));
}
